import { defaultPalette } from "./palettes/default";
import { lightPalette} from "./palettes/light";

type Palette = typeof defaultPalette;

export const palettes: Record<string, Palette> = {
  default: defaultPalette,
  light: lightPalette,
};
